import { movideskApi } from '@/lib/api/movidesk';

export const syncApi = {
  getLastSyncDates: async (): Promise<{
    lastTicketsSync: string | null;
    lastContractsSync: string | null;
  }> => {
    return await movideskApi.getLastSyncDates();
  },
};
